const config = {
  logIn: "user/request-otp",
  otpVerify: "user/verify-otp",
  myDonationsList: "donor/get",
  donorCreate: "donor/create",
  donorUpdate: "donor/update",
  donationDetailsCreate: "donations/online/create",
  downloadPDF: "pdf/download",
  upload: "file/upload",
  studentCreate: "student/create",
  studentGet: "student/get",
  studentUpdate: "student/update",
  sendanswer: "result/create",
  getresult: "result/get",
  exam: "examination/getExamForClient",
  getactiveexam: "examination/getExamDetails",
  getAnswersheet: "examination/getData",
  examination: "examination/get",
  sendanswer: "result/create",
  getresult: "result/get",
  refreshTocken: "user/refresh-token",
  enrollExam: "/enrolled/create",
  examdashboard: "examination/dashboardStudentData",
  razorPay: "razorpay/create/order",
  singleanswers:'result/attempted_questions',
  sendmoneyemail:'donor/send_mail',
  pdf10B:'form10be/getForm10B',
  getyear:'year/get',
  schoolcreate:'/school/create',
  studentcreate:'student/create'
};

export default config;
